import { RouterProvider } from 'react-router-dom';
import Intercept from './components/intercept';
import router from './router/index';

const App = () => {
  return (
    <Intercept>
      <RouterProvider router={ router } />
    </Intercept>
  );
};

export default App;
